module.exports = __webpack_public_path__ + "img/7.d970142b.png";